import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/css/PreviewSideMenu.css';

// What the side menu looks like in the app. This is a dark fan surface sitting
// inside a light admin, so it sets its own colours rather than inheriting the
// page's — it used to rely on .admin-main-panel's `color: #fff`, which was
// white text on a near-white page everywhere else and got fixed, leaving this
// preview with near-black labels on a near-black panel.
const SideMenuPreview = ({ items, backgroundImage }) => {
    const previewWidth = 320 * 2 / 3; // 2/3 of the smallest iOS device width (320px)
    const hasBackground = !!(backgroundImage && String(backgroundImage).trim());

    return (
        <div className="device-frame">
            <div className="side-menu-preview" style={{ width: previewWidth }}>
                <div
                    className="side-menu"
                    style={hasBackground ? {
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: '150% 100%', // Scale background to be larger
                        backgroundPosition: 'left center' // show the left part, as the app does
                    } : undefined}
                >
                    {items.map((item, index) => {
                        if (item.buttonType === "isSectionTitle") {
                            return (
                                <div key={item.id || index} className="section-header">
                                    {item.header}
                                </div>
                            );
                        }
                        return (
                            <div key={index} className="side-menu-item">
                                <span>{item.header}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

SideMenuPreview.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            header: PropTypes.string.isRequired,
            icon: PropTypes.string,
            buttonType: PropTypes.string
        })
    ).isRequired,
    // May legitimately be absent — a new experience has no artwork yet.
    backgroundImage: PropTypes.string
};

SideMenuPreview.defaultProps = {
    backgroundImage: ''
};

export default SideMenuPreview;
